import { Outlet } from 'react-router';

export const AccountPageOutlet: React.FC = function AccountPageOutlet() {
  return <Outlet />;
};
